import { gql } from '@apollo/client';

export const APPLY_STRATEGY = gql`
  query applyStrategyById($strategyId: String!, $limit: Float) {
    applyStrategyById(strategyId: $strategyId, limit: $limit) {
      order
      recommendedEntity
      type
      score
    }
  }
`;
